module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABT0lEQVQ4jaXRvWpVURAF4O/EJMRGEyy0iJYi6QJWvoBd1MY+gp2dWNj5CmJjoY2FAQsJksZHEIRgoyGGBEIKvSF6/QHJz70rRfbFw+GeEHTBFHv2mjUza6okcAnvMYE4HiNYwyyMluQCzuExvhZSH+cx1RA4g5u4jrcDgQms4iful+IKzzE/ZIrfOFuf4DumsVRE9jGGly1rVPgBVfFgGRexiLkacQynGsXPcAeTA4EnuIcdXMNMS9cBPpbYw1yVMgJe4w0eoddS3MdldB158GcUv8pOt7CBu7jhrz8DrOMzth1d4gt6kmwlkeRTkn6SD+XdjJkku0kOklxNciHJtiTdGulBIewneVjLbxbxTi33IklHkm9Duq0k6ZW/3SR7SW43OE+TdEZazLpSLnK67D6OV8OITaPqeFcEjkXbBCfG/wgsY7xKcoDOPwhMoXsIfjLkhr0zapkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/contact/邮箱.png
// module id = SqFN
// module chunks = 1